export const markAsComplete = traits => ({
  type: 'ADD_TO_HOME/MARK_AS_COMPLETE',
  payload: {},
})



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/AddToHome/AddToHome.actions.js